// styles
import styles from '../detail.module.scss';

// types
import type { EventLocatorItem } from '../../Sidebar/Sidebar.types';

// components
import { Lightbox } from 'components/lightbox/lightbox';
import { LightboxHeader } from 'components/lightbox/lightbox-header';
import { EventDetail } from './EventDetail';

type EventLightboxProps = {
  item: EventLocatorItem;
  openAcc: boolean;
  isAcc: boolean;
  onClose: () => void;
};

export function EventLightbox({ onClose, ...props }: Readonly<EventLightboxProps>) {
  const {
    item: { title },
  } = props;

  return (
    <Lightbox onCloseRequest={onClose} additionalClass="c-lightbox__locator">
      <div className={`c-lightbox__container ${styles.locatorLightbox} grid-container`}>
        <LightboxHeader handleClose={onClose} title={title} />
        <div className={styles.detailWrapper}>
          <EventDetail {...props} />
        </div>
      </div>
    </Lightbox>
  );
}
